import React, { Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGithub, faLinkedin, faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import {faEnvelope} from "@fortawesome/free-regular-svg-icons";

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="row">
          <div className="twelve columns">
             <ul className="social-links">
               <li><a href="http://github.com/yusufinthehouse" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faGithub} /></a></li>
               <li><a href="https://www.linkedin.com/in/myusufmaulana" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a></li>
               <li><a href="https://wa.me/6281220575075" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faWhatsapp} /></a></li>
               <li><a href="mailto:mail@yusuf-maulana.com" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a></li>
             </ul>

             <ul className="copyright" style={{ color: 'white' }}>
                <li>&copy; Copyright {(new Date().getFullYear())} Muhammad Yusuf Maulana</li>
             </ul>

          </div>
          <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js